import React, { Component } from "react";
import PropTypes from "prop-types";

class VirtualAnalyticsAppender extends Component {
  componentDidMount() {
    const { getAnalyticsPlaceHolders } = this.props;
    getAnalyticsPlaceHolders && getAnalyticsPlaceHolders();
  }

  componentWillUnmount() {
    const { clearAnalyticsPlaceHolders } = this.props;
    clearAnalyticsPlaceHolders && clearAnalyticsPlaceHolders();
  }

  render() {
    return <div />;
  }
}
VirtualAnalyticsAppender.propTypes = {
  clearAnalyticsPlaceHolders: PropTypes.func,
  getAnalyticsPlaceHolders: PropTypes.func
};
export default VirtualAnalyticsAppender;



// WEBPACK FOOTER //
// ./src/components/VirtualAnalyticsAppender/VirtualAnalyticsAppender.js